import React, { Component } from "react";
import { Popover, Tag } from "antd";

import AppContext from "../AppContext";

class StudentTag extends Component {
  static contextType = AppContext;

  state = {
    visible: false
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  Content = () => {
    const { student } = this.props;

    return (
      <div>
        <div>
          <strong>zID:</strong> {student.zid}
        </div>

        <div>
          <strong>Email:</strong>{" "}
          <a href={`mailto:${student.email}`}>{student.email}</a>
        </div>
      </div>
    );
  };

  render() {
    const { student } = this.props;
    const { visible } = this.state;

    if (!this.context.isAdmin)
      return <Tag style={{ margin: 3 }}>{student.name}</Tag>;
      
    return (
      <Popover
        content={this.Content()}
        title={student.name}
        trigger="click"
        visible={visible}
        onVisibleChange={this.handleVisibleChange}
      >
        <Tag style={{ margin: 3 }}>
          {student.name} ({student.zid})
        </Tag>
      </Popover>
    );
  }
}

export default StudentTag;
